module.exports = __webpack_public_path__ + "static/media/saved_cave_marker.c85972b8.svg";